import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eldnowConfig: TSPConfig = {
  key: 'eldnow',
  name: 'ELD Now',
  imageName: 'ELDNow',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your ELD Now profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default eldnowConfig;
